import { useMemo } from "react";
import { Container, Grid } from "@mui/material";
import Heartbanner from "./src/heartbanner";
import AboutWbs from "./src/aboutWbs";
import SponsoredFurtherTraining from "./src/sponsoredFurtherTraining";
import LegalInformation from "./src/legalInformation";

const FooterGrid = () => {
  const gridItems = useMemo(
    () => [
      { key: "sft", md: 5, content: <SponsoredFurtherTraining /> },
      { key: "about", md: true, sm: 6, xs: 12, content: <AboutWbs /> },
      { key: "legal", md: true, sm: 6, xs: 12, content: <LegalInformation /> },
    ],
    [],
  );
  return (
    <Grid
      data-testid="footer-grid"
      container
      spacing={8}
      sx={{ pt: 10, pb: 4, textAlign: "center" }}
    >
      {gridItems.map((item) => (
        <Grid item key={item.key} md={item.md} sm={item.sm} xs={item.xs}>
          {item.content}
        </Grid>
      ))}
    </Grid>
  );
};

const Footer = () => {
  return (
    <>
      <Heartbanner />
      <Container maxWidth="xl">
        <FooterGrid />
      </Container>
    </>
  );
};

export default Footer;
